import { Exercise } from '@repo/types/src/glow-up';
import { ExerciseCard } from './ExerciseCard';

type ListProps = {
  exercises: Exercise[];
  refetch: () => void;
};

export const ExerciseList = ({ exercises, refetch }: ListProps) => {
  return (
    <div className="flex flex-col gap-4 h-full overflow-auto pb-12">
      <div className="flex flex-wrap gap-4">
        {exercises.map((exercise) => (
          <ExerciseCard
            key={exercise.id}
            exercise={exercise}
            refetch={refetch}
          />
        ))}
      </div>
    </div>
  );
};
